/** @jsx jsx */
import { FinnoScorePage } from '@composite';
import { Layout, StaticSEO } from '@core';
import { jsx } from 'theme-ui';
import RedirectBanner from '../components/RedirectBanner';

export default () => (
  <Layout>
    <StaticSEO pageId='finnoscore' />
    <RedirectBanner targetUrl='https://www.innoscore.com/{locale}/industries/scoring-retail-banking' />
    <FinnoScorePage />
  </Layout>
);
